export default function (queryParams, extraParams) {
  const joinedParams = { ...queryParams }
  Object.keys({ ...extraParams }).forEach(key => {
    if (joinedParams[key]) {
      joinedParams[key] = [extraParams[key], joinedParams[key]].join(',')
    } else {
      joinedParams[key] = extraParams[key]
    }
  })

  return joinedParams
}
